'use client'

import { Button } from '@/components/Button'
import { Heading } from '@/components/Heading'
import { useTranslation } from 'react-i18next'

export default function NotFound() {
    const { t } = useTranslation()
    return (
        <div className="text-center mb-20">
            <Heading align="center" tag="h2" text={t('eshop.notFound.title')} />
            <p className="mt-6">{t('eshop.notFound.description')}</p>
            <Button rootClasses="mt-6" url="/eshop">
                {t('eshop.notFound.button')}
            </Button>
        </div>
    )
}
